import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "alert-2--sprite",
  "use": "alert-2--sprite-usage",
  "viewBox": "0 0 67 66",
  "content": "<symbol viewBox=\"0 0 67 66\" xmlns=\"http://www.w3.org/2000/svg\" id=\"alert-2--sprite\">\n<path d=\"M3.25 59.125H63.75L33.5 6.875L3.25 59.125ZM36.25 50.875H30.75V45.375H36.25V50.875ZM36.25 39.875H30.75V28.875H36.25V39.875Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol